import {
  type ConversationCartVendor,
  type ConversationVendor,
} from './ConversationTurnItem'

const AMAZON_BUSINESS_VENDOR_ID = 'amazon-business'

export const SourceChannels = {
  AMAZON: 'amazon',
  CATALOG: 'catalog',
} as const

export const deriveSourceChannel = (vendor?: Nullable<ConversationVendor>) =>
  vendor?.id === AMAZON_BUSINESS_VENDOR_ID
    ? SourceChannels.AMAZON
    : SourceChannels.CATALOG

export const deriveCartSourceChannel = (
  vendors: ConversationCartVendor[] = []
) =>
  vendors.some(({ vendor }) => vendor?.id === AMAZON_BUSINESS_VENDOR_ID)
    ? SourceChannels.AMAZON
    : SourceChannels.CATALOG
